import React from 'react';

import PropTypes from 'prop-types';

import CoshhOptions from 'components/projectCoshh/components/CoshhOptions';

export default function CoshhRow({
  coshhDocument,
  onCoshhDocumentRowClick,
  onDeleteClick,
  onDownloadClick,
}) {
  return (
    <tr
      className='handshq__tr--clickable handshq__tr--taller options__toggle-container tw-group/row hover:tw-bg-grey-025'
      onClick={() => onCoshhDocumentRowClick(coshhDocument)}
    >
      <td className='tw-border-grey-100 tw-py-1 tw-font-medium tw-text-grey-900'>
        <div className='tw-flex tw-h-10 tw-items-center'>
          <span className='truncated-text-container--wrapped truncated-text-container--two-lines'>
            {coshhDocument.attributes.title}
          </span>
        </div>
      </td>
      <td className='tw-border-grey-100 tw-py-1'>
        <div className='tw-flex tw-h-10 tw-items-center'>
          <span className='truncated-text-container--wrapped truncated-text-container--two-lines'>
            {coshhDocument.attributes.manufacturer}
          </span>
        </div>
      </td>
      <td className='tw-border-grey-100'>
        <div className='tw-flex tw-h-8 tw-items-center'>
          {coshhDocument.attributes.reference}
        </div>
      </td>
      <td className='tw-border-grey-100'>
        <CoshhOptions
          coshhDocument={coshhDocument}
          onDeleteClick={onDeleteClick}
          onDownloadClick={onDownloadClick}
        />
      </td>
    </tr>
  );
}

CoshhRow.propTypes = {
  coshhDocument: PropTypes.object.isRequired,
  onCoshhDocumentRowClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
};
